import React from 'react';
import PropTypes from 'prop-types';
import StarRating from 'wonderbly-components/lib/StarRating';
import Rule from 'wonderbly-components/lib/Rule';
import RichText from '../../Prismic/RichText';
import cx from 'classnames';
import './GrownUpReview.scss';

const GrownUpReview = props => (
  <div
    className={cx('grown-up-reviews', {
      hidden: props.hidden,
    })}>
    {props.reviews.map((review, index) => (
      <div className="grown-up-review" key={index}>
        <div className="grown-up-review-meta">
          <div data-animate-text="first">
            <StarRating stars={review.starRating}/>
          </div>
          <div className="reviewer-info">
            <h5 className="text-kilo review-name" data-animate-text="second">{review.reviewerName}</h5>
            {review.reviewersLocation && (
              <h6 className="text-milli review-location" data-animate-text="third">
                {review.reviewersLocation}
              </h6>
            )}
          </div>
        </div>
        <div className="grown-up-review-content">
          <h4 className="text-mega" data-animate-text={review.reviewersLocation ? 'forth' : 'third'}>{review.title}</h4>
          <RichText
            fields={review.description}
            animateText={review.reviewersLocation ? 'fifth' : 'forth'}
          />
        </div>
        <Rule type="medium" />
      </div>
    ))}
  </div>
);

GrownUpReview.propTypes = {
  hidden: PropTypes.bool.isRequired,
  reviews: PropTypes.arrayOf(PropTypes.shape({
    starRating: PropTypes.string.isRequired,
    reviewerName: PropTypes.string,
    reviewersLocation: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.array.isRequired
  })).isRequired
};

export default GrownUpReview;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductReviewList/GrownUpReview/GrownUpReview.js